import AppConfigStore from '../../stores/AppConfigStore';
import {BlogView} from 'epic-minimalist-blog/app/scripts';
import PropTypes from 'prop-types';
import React from 'react';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';

class BlogWrapper extends React.Component {
    static getStores() {
        return [AppConfigStore];
    }

    static getPropsFromStores() {
        return {
            alertMessage: AppConfigStore.getState().globalAlert
        };
    }
    static propTypes = {
        alertMessage: PropTypes.object, //eslint-disable-line
        getMessage: PropTypes.func
    };

    render() {
        const metaTitle = this.props.getMessage('epic.fortnite.blog.meta.title');

        return (
            <div className="blog-wrapper">
                <BlogView
                    {...this.props}
                    overrideMetaTitle={metaTitle}
                    enableAutoShortDescription={true} />
            </div>
        );
    }
}

export default withLocalization(BlogWrapper);
